import { createSlice } from "@reduxjs/toolkit";

const INITIAL_STATE = { isStoreOrderFetching: true };

const syncReducers = {
  setStore: (state, { payload }) => {
    return { ...state, ...payload };
  },
  setStoreBalance: (state, { payload }) => {
    return { ...state, balance: payload.balance, isStoreOrderFetching: false };
  },
  clearStore: () => {
    return INITIAL_STATE;
  },
};

const store = createSlice({
  name: "store",
  initialState: INITIAL_STATE,
  reducers: syncReducers,
});

export const { setStore, setStoreBalance, clearStore } = store.actions;

export default store.reducer;
